import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const renewEmployerBenefits = ({ benefitIds }) =>
  call(websocketFetch, 'renew_employer_benefits', { benefit_ids: benefitIds });
